"use strict";

jQuery(document).ready(function ($) {});
//# sourceMappingURL=app.js.map
